import { useSnsShareUrl } from '~/hooks/useSnsShareUrl'
import { NEXT_PUBLIC_WEAR2_WEB_URL } from '~/lib/env'

export const useCoordinateDetailShareUrl = (
  coordinateId: number,
  userName: string
) => {
  const { twitterShareUrl, facebookShareUrl, lineShareUrl } = useSnsShareUrl({
    shareUrl: `${NEXT_PUBLIC_WEAR2_WEB_URL}/${userName}/${coordinateId}/`,
    utmCampaign: `snapID_${coordinateId}`,
    hashtags: ['WEARコーデ'],
  })
  return { twitterShareUrl, facebookShareUrl, lineShareUrl }
}
